<!--
  WARNING!!!!
  don't mess code here, do customization more at templates or add new templates, that are more custom for project !!!!!
 -->
<div
  class="bn-select bn-select--{{ itemStyle() }} {{ size() === 'auto' ? '' : 'bn-select--' + size() }}"
  [ngClass]="{
    'bn-form__control--error': ngControl && ngControl.control?.touched && !ngControl.control?.valid,
  }"
  [ngStyle]="{
    width: width(),
    minWidth: minWidth(),
  }">
  <label class="bn-select__label-wrapper">
    @if (label()) {
      <div class="bn-form__label">
        {{ label() }}
      </div>
    }

    <div
      class="bn-select__container"
      [ngClass]="{ 'has-left-icon': leftIcon() }">
      @if (isRequired && !hideRequiredLabel() && !disabled && !readonly()) {
        <div class="position-relative">
          <span class="bn-form__required-mark position-absolute">Required</span>
        </div>
      }
      <div
        class="bn-select__container__dropdown"
        [ngClass]="{
          'bn-select__container__dropdown--open': isOpened(),
        }">
        @if (leftIcon()) {
          <div
            class="bn-select__icon bn-select__icon--left {{ leftIconClass() }}"
            [ngClass]="{
              'bn-select__icon--has-circle': leftIconCircle(),
            }">
            <fa-icon
              [icon]="leftIcon()"
              [size]="size() === 'xs' ? 'xs' : size() === 'sm' ? 'sm' : size() === 'xxs' ? '2xs' : '1x'" />
          </div>
        }
        @if (itemStyle() === 'secondary') {
          <span class="bn-select__wrap">
            @if (innerLabel()) {
              <span
                class="bn-select__inner-label"
                [ngClass]="{
                  'ms-1': leftIcon(),
                }"
                >{{ 'DROPDOWNS.INNER_LABEL' | translate: { label: innerLabel() } }}</span
              >
            }
            <span class="bn-select__values">
              {{ selectedItems() | secondarySelectedItemsLabel: showOnlyCount() : showFirstNPlusMore() : selectedItemsLabels() }}
            </span>
          </span>
          <span class="bn-select__arrow">
            @if (isLoading()) {
              <span class="bn-loading--xxs d-flex align-items-center justify-content-center w-100">
                <div class="bn-loading__spinner"></div>
              </span>
            } @else if (!(clearable() && (selectedItems() | truthySelectAnythingSelected))) {
              <span class="bn-select__arrow__icon"></span>
            }
          </span>
          @if (clearable() && !disabled && !readonly() && (selectedItems() | truthySelectAnythingSelected)) {
            <span
              class="bn-select__secondary-clear"
              (click)="onClearAll($event)">
              <span class="bn-select__secondary-clear__icon"></span>
            </span>
          }
        }

        <ng-select
          #primeSelect
          class="bn-select
            ng-select-{{ isMinSize() ? 'min-' + size() : size() }}
            ng-select--dropdown-width--{{ dropdownWidth() }}
            ng-select--dropdown-width-mobile--{{ dropdownWidthMobile() }}
            ng-select--border-top-left-radius--{{ borderRadius().at(0) }}
            ng-select--border-top-right-radius--{{ borderRadius().at(1) }}
            ng-select--border-bottom-right-radius--{{ borderRadius().at(2) }}
            ng-select--border-bottom-left-radius--{{ borderRadius().at(3) }}"
          [attr.id]="id()"
          [bindLabel]="bindLabel()"
          [bindValue]="bindValue()"
          [class.hide-arrow]="hideArrow()"
          [class.ng-select--icon-clear]="clearTemplate() === 'clearButton'"
          [class.ng-select--text-clear]="clearTemplate() === 'textClearButton'"
          [clearable]="clearable()"
          [closeOnSelect]="closeOnSelect()"
          [disabled]="disabled"
          [groupBy]="groupBy()"
          [hideSelected]="hideSelected()"
          [inputAttrs]="{ id: id() + '-text-box' }"
          [items]="filteredItems"
          [labelForId]="labelForId()"
          [loading]="isLoading()"
          [maxSelectedItems]="maxSelectedItems()"
          [multiple]="isMultipleSelect()"
          [ngClass]="{
            'ng-select--has-icon': leftIcon(),
            'ng-select--hide-clear': hideClear(),
            'ng-select--hide-multiple-selected-items': hideMultipleSelectedItems(),
          }"
          [placeholder]="placeholder()"
          [readonly]="readonly() || (isLoading() && !virtualScroll())"
          [required]="required()"
          [searchFn]="disableInternalSearch() ? (findAllSearchFn() ?? defaultFindAllSearchFn) : null"
          [searchable]="searchable()"
          [selectOnTab]="true"
          [selectableGroup]="selectableGroup()"
          [virtualScroll]="virtualScroll()"
          [(ngModel)]="selectedItems"
          (addEvent)="handleAdd($event)"
          (blur)="onBlur($event)"
          (clear)="onClearAll()"
          (close)="onClose()"
          (ngModelChange)="onModelChange($event)"
          (open)="onOpen()"
          (removeEvent)="handleRemove($event)"
          (scroll)="onScroll($event)"
          (scrollToEnd)="onScrollToEnd()"
          (search)="onSearch($event)">
          <!-- OptGroup -->
          <ng-template
            let-country="country"
            let-index="index"
            let-item$="item$"
            let-items="items"
            ng-optgroup-tmp>
            <ng-template
              *ngTemplateOutlet="
                optgroupTemplate.optgroupTemplate();
                context: { flagSize: flagSize(), groupBy: groupBy(), uppercase: isGroupUpperCase(), item$ }
              " />
          </ng-template>

          <!-- Header (optional) -->
          @if (headerText()) {
            <ng-template ng-header-tmp>
              <ng-template
                *ngTemplateOutlet="
                  selectHeaderTemplate.selectWithHeaderTextTemplate();
                  context: {
                    headerText: headerText(),
                    id: id(),
                    searchable: searchable(),
                    searchText: dropdownSearchFilter,
                    searchPlaceholder: searchPlaceholder(),
                    isLoading: isLoading(),
                  }
                " />
            </ng-template>
          }

          <!-- Multi select -->
          @if (isMultipleSelect() === true) {
            <ng-template
              let-clear="clear"
              let-items="items"
              ng-multi-label-tmp>
              <ng-template *ngTemplateOutlet="multiLabelTemplate.labelTemplate(); context: { items, clear, flagSize: flagSize(), type: 'select' }" />
            </ng-template>
          } @else {
            <!-- Single select -->
            <ng-template
              let-clear="clear"
              let-item="item"
              ng-label-tmp>
              <ng-template
                *ngTemplateOutlet="
                  labelTemplate.labelTemplate();
                  context: {
                    item,
                    clear,
                    clearable: clearable(),
                    flagSize: flagSize(),
                    hideName: hideName(),
                    type: 'badge',
                  }
                " />
            </ng-template>
          }

          <!-- Option -->
          <ng-template
            let-country="country"
            let-index="index"
            let-item$="item$"
            let-search="search"
            ng-option-tmp>
            <ng-template
              *ngTemplateOutlet="
                optionTemplate.optionTemplate();
                context: {
                  flagSize: flagSize(),
                  item$,
                  hideName: hideName(),
                  search,
                  showEndSelectedIcon: this.showEndSelectedIcon(),
                }
              " />
          </ng-template>

          <!-- Clear button -->
          <ng-template ng-clearbutton-tmp>
            @if (clearTemplate() === 'clearButton') {
              <ng-template *ngTemplateOutlet="clearbuttonTemplate.clearButton()" />
            } @else {
              <ng-template *ngTemplateOutlet="clearbuttonTemplate.textClearButton()" />
            }
          </ng-template>
        </ng-select>
      </div>
    </div>
    <p class="bn-form__description"><ng-content /></p>
  </label>

  <bn-web-ui-formcontrol-errors
    [control]="ngControl.control"
    [inputDisplayName]="displayName()" />
</div>

<!-- Shared select templates -->
<bn-web-ui-multi-label-select-template #multiLabelTemplate />
<bn-web-ui-optgroup-select-template #optgroupTemplate />
<bn-web-ui-header-select-template
  #selectHeaderTemplate
  (closeChange)="onClose()"
  (filterChange)="onSearch({ term: $event })" />
<bn-web-ui-clearbutton-select-template
  #clearbuttonTemplate
  (clear)="onClearAll()" />
<bn-web-ui-option-select-template #optionTemplate />
<bn-web-ui-label-select-template
  #labelTemplate
  (clear)="onClearItem($event)" />
